import {Routes, Route, useLocation} from 'react-router-dom';
import ROUTES, {isResultCommentPublicPath} from '../../utils/routes';
import SSO from '../../components/SSO';
import Login from '../../pages/Login';
import ForgotPassword from '../../pages/ForgotPassword';
import EnterCode from '../../pages/EnterCode';
import NewPassword from '../../pages/NewPassword';
import Registration from '../../pages/Registration';
import RegistrationNew from '../../pages/RegistrationNew';
import RegistrationCorporate from '../../pages/RegistrationCorporate';
import ConfirmRegistration from '../../pages/ConfirmRegistration';
import Installation from '../../pages/Installation';
import CheckData from '../../pages/CheckData';
import AccessDenied from '../../pages/AccessDenied/AccessDenied';
import SsoWarning from '../../pages/SsoWarning/SsoWarning';
import SidebarLayout from '../SideBar/SidebarLayout';
import {useSelector} from 'react-redux';
import Inspections from '../../pages/Inspections';
import CorrectiveActions from '../../pages/CorrectiveActions';
import EquipmentManagement from '../../pages/EquipmentManagement';
import FuelReceiptForm from '../../pages/FuelReceiptForm';
import LogSheets from '../../pages/LogSheets';
import ServiceRequest from '../../pages/ServiceRequest';
import UserManagement from '../../pages/UserManagement';
import FormBuilder from '../../pages/FormBuilder';
import Profile from '../../pages/Profile';
import CreateEquipment from '../../pages/CreateEquipment';
import Facility from '../../pages/Facility';
import InspectionsForm from '../../pages/InspectionsForm';
import EquipmentType from '../../pages/EquipmentType';
import EquipmentTypeEdit from '../../pages/EquipmentTypeEdit';
import FillInspection from '../../pages/FillInspection';
import Report from '../../pages/Report';
import Agancy from '../../pages/Agancy';
import ErrorPage from '../../pages/404Page';
import EquipmentTypeEditNew from '../../pages/EquipmentTypeEditNew';
import AssignedInspections from '../../pages/AssignedInspections';
import Settings from '../../pages/Settings';
import AgencyDetail from '../../pages/AgencyDetail';
import AgencyTrial from '../../pages/AgencyTrial';
import Dashboard from '../../pages/Dashboard';
import AdvancedMetrics from '../../pages/AdvancedDashboard';
import FBOSettings from '../../pages/FBOSettings';
import CorporateAccount from '../../pages/CorporateAccount';
import CorporateDashboard from '../../pages/CorporateDashboard';
import InvitedFbo from '../../pages/InvitedFbo';
import CorporateSettings from '../../pages/CorporateSettings';
import FBOManagement from '../../pages/FBOManagement';
import CorporateDetails from '../../pages/CorporateDetails';
import ToolsManagement from '../../pages/ToolsManagement';
import ToolsCreate from '../../pages/ToolsCreate';
import AgencyInactive from '../../pages/AgencyInactive';
import Forms from '../../pages/Forms';
import CustomInspections from '../../pages/CustomInspections';
import BuildInspection from '../../pages/BuildInspection';
import CreateNewForm from '../../pages/CreateNewForm';
import CustomInspectionsDetails from '../../pages/CustomInspectionsDetails';
import CustomInspectionForms from '../../pages/CustomInspectionForms';
import HistoryLog from '../../pages/HistoryLogs/HistoryLog';
import ReportsHealthy from '../../pages/ReportsHealthy/ReportsHealthy';
import ReportsHealthyList from '../../pages/ReportsHealthyList/ReportsHealthyList';
import LanguageManagement from '../../pages/LanguageManagement';
import ResultCommentPublic from '../../pages/ResultCommentPublic';

export const routesWithElement = [
  // Dashboard routes
  {
    path: ROUTES.private.dashboard,
    element: <Dashboard />,
    permisstions: [],
  },
  {
    path: ROUTES.private.dashboardRedirect(':agency_id'),
    element: <Dashboard />,
    permisstions: [],
  },
  {
    path: ROUTES.private.advancedMetrics,
    element: <AdvancedMetrics />,
    permisstions: [],
  },

  // Custom Inspections Routes
  {
    path: ROUTES.private.customInspections,
    element: <CustomInspections />,
    permisstions: [],
  },
  {
    path: ROUTES.private.corporateCustomInspections,
    element: <CustomInspections />,
    permisstions: [],
  },
  {
    path: ROUTES.private.customInspectionsBuild,
    element: <BuildInspection />,
    permisstions: [],
  },
  {
    path: ROUTES.private.corporateCustomInspectionsBuild,
    element: <BuildInspection />,
    permisstions: [],
  },
  {
    path: ROUTES.private.customInspectionsEdit(':id'),
    element: <BuildInspection />,
    permisstions: [],
  },
  {
    path: ROUTES.private.corporateCustomInspectionsEdit(':id'),
    element: <BuildInspection />,
    permisstions: [],
  },
  {
    path: ROUTES.private.corporateCustomInspectionsDetails(':id'),
    element: <CustomInspectionsDetails />,
    permisstions: [],
  },
  {
    path: ROUTES.private.customInspectionsForms(':id'),
    element: <CustomInspectionForms />,
    permisstions: [],
  },
  {
    path: ROUTES.private.inspectionDetail(':id'),
    element: <FillInspection />,
    permisstions: [],
  },

  // Forms routes
  {
    path: ROUTES.private.formsCreate,
    element: <CreateNewForm />,
    permisstions: [],
  },
  {
    path: ROUTES.private.formsEdit(':id'),
    element: <CreateNewForm />,
    permisstions: [],
  },
  {
    path: ROUTES.private.corporateForms,
    element: <Forms />,
    permisstions: [],
  },
  {
    path: ROUTES.private.corporateFormsEdit(':id'),
    element: <CreateNewForm />,
    permisstions: [],
  },
  {
    path: ROUTES.private.corporateFormsCreate,
    element: <CreateNewForm />,
    permisstions: [],
  },
  {
    path: ROUTES.private.forms,
    element: <Forms />,
    permisstions: [],
  },

  // Inspections routes
  {
    path: ROUTES.private.inspections,
    element: <Inspections />,
    permisstions: ['inspection', 'inspection_detail'],
  },
  {
    path: ROUTES.private.inspectionForm,
    element: <InspectionsForm />,
    permisstions: [],
  },
  {
    path: ROUTES.private.inspectionForms,
    element: <InspectionsForm />,
    permisstions: [],
  },
  {
    path: ROUTES.private.inspectionFormEdit(':id'),
    element: <FormBuilder />,
    permisstions: [],
  },

  // Facility routes
  {
    path: ROUTES.private.facility,
    element: <Facility />,
    permisstions: [],
  },
  {
    path: ROUTES.private.facilityEdit(':id'),
    element: <EquipmentTypeEdit editType={'facility'} />,
    permisstions: [],
  },

  // Log Sheets routes
  {
    path: ROUTES.private.logSheets,
    element: <LogSheets />,
    permisstions: [],
  },

  // Observation routes
  {
    path: ROUTES.private.observation,
    element: <ServiceRequest />,
    permisstions: [],
  },

  // User Management routes
  {
    path: ROUTES.private.management,
    element: <UserManagement />,
    permisstions: [],
  },

  // Tools routes
  {
    path: ROUTES.private.tools,
    element: <ToolsManagement />,
    permisstions: [],
  },
  {
    path: ROUTES.private.toolsEdit(':id'),
    element: <ToolsCreate />,
    permisstions: [],
  },
  {
    path: ROUTES.private.toolsCreate,
    element: <ToolsCreate />,
    permisstions: [],
  },

  // Report routes
  {
    path: ROUTES.private.report,
    element: <Report />,
    permisstions: [],
  },

  // Fuel Receipt routes
  {
    path: ROUTES.private.receiptForm,
    element: <FuelReceiptForm />,
    permisstions: [],
  },

  // FBO routes
  {
    path: ROUTES.private.fboAll,
    element: <Agancy />,
    permisstions: [],
  },
  {
    path: ROUTES.private.fboInvited,
    element: <InvitedFbo />,
    permisstions: [],
  },
  {
    path: ROUTES.private.fboTrial,
    element: <AgencyTrial />,
    permisstions: [],
  },
  {
    path: ROUTES.private.fboInactive,
    element: <AgencyInactive />,
    permisstions: [],
  },
  {
    path: ROUTES.private.fboDetail(':id'),
    element: <AgencyDetail />,
    permisstions: [],
  },

  // Corporate routes
  {
    path: ROUTES.private.corporateActive,
    element: <CorporateAccount type={'active'} />,
    permisstions: [],
  },
  {
    path: ROUTES.private.corporateInactive,
    element: <CorporateAccount type={'inactive'} />,
    permisstions: [],
  },
  {
    path: ROUTES.private.corporateDetail(':id'),
    element: <CorporateDetails />,
    permisstions: [],
  },
  {
    path: ROUTES.private.corporateDashboard,
    element: <CorporateDashboard />,
    permisstions: [],
  },
  {
    path: ROUTES.private.fboManagement,
    element: <FBOManagement />,
    permisstions: [],
  },

  // Settings routes
  {
    path: ROUTES.private.settings,
    element: <Settings />,
    permisstions: [],
  },
  {
    path: ROUTES.private.corporateSettings,
    element: <CorporateSettings />,
    permisstions: [],
  },
  {
    path: ROUTES.private.fboSettings,
    element: <FBOSettings />,
    permisstions: [],
  },

  // Equipment routes
  {
    path: ROUTES.private.equipmentType,
    element: <EquipmentType />,
    permisstions: [],
  },
  {
    path: ROUTES.private.equipmentTypeEdit(':id', ':revision'),
    element: <EquipmentTypeEditNew editType={'equipment'} />,
    permisstions: [],
  },
  {
    path: ROUTES.private.equipmentTypeAssigned,
    element: <AssignedInspections />,
    permisstions: [],
  },
  {
    path: ROUTES.private.equipment,
    element: <EquipmentManagement />,
    permisstions: ['equipment_management'],
  },
  {
    path: ROUTES.private.equipmentEdit(':id'),
    element: <CreateEquipment />,
    permisstions: [],
  },
  {
    path: ROUTES.private.createEquipment,
    element: <CreateEquipment />,
    permisstions: [],
  },
  {
    path: ROUTES.private.customEquipmentType,
    element: <EquipmentType />,
    permisstions: [],
  },

  // History Logs routes
  {
    path: ROUTES.private.historyLogs,
    element: <HistoryLog />,
    permisstions: [],
  },

  // Profile routes
  {
    path: ROUTES.private.profile,
    element: <Profile />,
    permisstions: [],
  },

  // SSO Warning routes
  {
    path: ROUTES.private.sso_warning,
    element: <SsoWarning />,
    permisstions: [],
  },

  // Actions routes
  {
    path: ROUTES.private.actions,
    element: <CorrectiveActions />,
    permisstions: [],
  },

  {
    path: ROUTES.private.reportsHealthyList,
    element: <ReportsHealthyList />,
    permisstions: [],
  },

  {
    path: ROUTES.private.reportsHealthy(':id'),
    element: <ReportsHealthy />,
    permisstions: [],
  },
  {
    path: ROUTES.private.languageManagement,
    element: <LanguageManagement />,
    permisstions: ["locale_management"],
  },

  // Error routes
  {
    path: '*',
    element: <ErrorPage />,
    permisstions: [],
  },
];

const RouteLayout = ({children}) => {
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);
  const userPermissions = useSelector(state => state?.rootReducer?.loginSlice?.user?.permissions);
  const location = useLocation();
  const userHasPermissions = (permissions)=>{
    return permissions.every(permission => userPermissions?.includes(permission));
  }

  const bareResultComment = isResultCommentPublicPath(location.pathname);

  return (
    <>
      {children}
      <>
        {bareResultComment ? (
          <Routes>
            <Route
              path={ROUTES.public.resultCommentRoute}
              element={<ResultCommentPublic />}
            />
          </Routes>
        ) : userInfo ? (
          location.pathname === ROUTES.private.sso_warning ? (
            <Routes>
              <Route path={ROUTES.private.sso_warning} element={<SsoWarning />} />
            </Routes>
          ) : (
          <SidebarLayout>
            <Routes>
              {routesWithElement.map(route => (
                userHasPermissions(route.permisstions) && (
                <Route
                  key={route.path}
                  path={route.path}
                  element={route.element}
                  />
                )
              ))}
            </Routes>
          </SidebarLayout>
          )
        ) : (
          <Routes>
            {/* Public Routes */}
            <Route path={ROUTES.public.ssoAuthorization} element={<SSO />} />
            <Route path={ROUTES.public.login} element={<Login />} />
            <Route
              path={ROUTES.public.forgotPassword}
              element={<ForgotPassword />}
            />
            <Route path={ROUTES.public.enterCode} element={<EnterCode />} />
            <Route
              path={ROUTES.public.createPassword}
              element={<NewPassword />}
            />
            <Route path={ROUTES.public.signUp} element={<Registration />} />
            <Route
              path={ROUTES.public.registration}
              element={<RegistrationNew />}
            />
            <Route
              path={ROUTES.public.registrationCorporate}
              element={<RegistrationCorporate />}
            />
            <Route
              path={ROUTES.public.confirmRegistration}
              element={<ConfirmRegistration />}
            />
            <Route
              path={ROUTES.public.installation}
              element={<Installation />}
            />
            <Route path={ROUTES.public.checkData} element={<CheckData />} />
            <Route
              path={ROUTES.public.accessDenied}
              element={<AccessDenied />}
            />
          </Routes>
        )}
      </>
    </>
  );
};

export default RouteLayout;
